  const advertisers = [
    {
        "id": "7826",
        "network": "Awin",
        "name": "Converse",
        "url": "https://www.converse.com/uk"
    },
    {
        "id": 43729,
        "network": "Rakuten",
        "name": "HOKA US",
        "url": "https://www.hoka.com/en/us/"
    },
       {
        "id": "17203",
        "network": "Awin",
        "name": "Hoka GB",
        "url": "https://www.hoka.com/en/gb/"
    },

     {
        "id": "50726",
        "network": "Rakuten",
        "name": "Jacquemus",
        "url": "https://www.jacquemus.com"
    },

      {
        "id": 37501,
        "network": "Rakuten",
        "name": "Jimmy Choo UK",
        "url": "https://www.jimmychoo.com"
    },

      {
        "id": 37499,
        "network": "Rakuten",
        "name": "Jimmy Choo US",
        "url": "https://us.jimmychoo.com"
    },

     {
        "id": 39491,
        "network": "Rakuten",
        "name": "Jimmy Choo EU",
        "url": "https://row.jimmychoo.com"
    },

        {
        "id": 53573,
        "network": "Rakuten",
        "name": "Balmain GB",
        "url": "https://gb.balmain.com/"
    },

        {
        "id": 53573,
        "network": "Rakuten",
        "name": "Balmain US",
        "url": "https://us.balmain.com/"
    },

      {
        "id": 53573,
        "network": "Rakuten",
        "name": "Balmain FR",
        "url": "https://fr.balmain.com/"
    },

     {
        "id": 53573,
        "network": "Rakuten",
        "name": "Balmain IT",
        "url": "https://de.balmain.com/"
    },

      {
        "id": 53573,
        "network": "Rakuten",
        "name": "Balmain IT",
        "url": "https://it.balmain.com/"
    },


      {
        "id": 47194,
        "network": "Rakuten",
        "name": "Loewe",
        "url": "https://www.loewe.com"
    },
    
      {
        "id": 52692,
        "network": "Rakuten",
        "name": "Mcqueen US",
        "url": "https://www.alexandermcqueen.com/en-us/"
    },
       {
        "id": 36328,
        "network": "Rakuten",
        "name": "Mcqueen GB",
        "url": "https://www.alexandermcqueen.com/en-gb/"
    },
       {
        "id": 36328,
        "network": "Rakuten",
        "name": "Mcqueen FR",
        "url": "https://www.alexandermcqueen.com/en-fr/"
    },

       {
        "id": 36328,
        "network": "Rakuten",
        "name": "Mcqueen IT",
        "url": "https://www.alexandermcqueen.com/en-it/"
    },
       {
        "id": 36328,
        "network": "Rakuten",
        "name": "Mcqueen DE",
        "url": "https://www.alexandermcqueen.com/en-de/"
    },
      {
        "id": 50522,
        "network": "Rakuten",
        "name": "Versace",
        "url": "https://www.versace.com"
    },
   
      {
        "id": 35663,
        "network": "Rakuten",
        "name": "Mytheresa UK",
        "url": "https://www.mytheresa.com/gb/"
    },
     {
        "id": 43172,
        "network": "Rakuten",
        "name": "Mytheresa US",
        "url": "https://www.mytheresa.com/us/"
    },
     {
        "id": 35663,
        "network": "Rakuten",
        "name": "Mytheresa FR",
        "url": "https://www.mytheresa.com/fr/"
    },
    {
        "id": 35663,
        "network": "Rakuten",
        "name": "Mytheresa IT",
        "url": "https://www.mytheresa.com/it/"
    },
    {
        "id": 35663,
        "network": "Rakuten",
        "name": "Mytheresa DE",
        "url": "https://www.mytheresa.com/de/"
    },
    {
        "id": 13867,
        "network": "Rakuten",
        "name": "Bloomingdale's",
        "url": "https://www.bloomingdales.com"
    },
    {
        "id": "45342",
        "network": "Rakuten",
        "name": "HOKA CA",
        "url": "https://www.hokaoneone.com"
    },
     {
        "id": "1011l52cEM",
        "network": "Partnerize",
        "name": "Bottega Veneta GB",
        "url": "https://www.bottegaveneta.com/en-gb"
    },
     {
        "id": "1100l52aaI",
        "network": "Partnerize",
        "name": "Bottega Veneta US",
        "url": "https://www.bottegaveneta.com/en-us"
    },
     {
        "id": "1011l52cEL",
        "network": "Partnerize",
        "name": "Bottega Veneta IT",
        "url": "https://www.bottegaveneta.com/it-it"
    },
     {
        "id": "1011l52cEL",
        "network": "Partnerize",
        "name": "Bottega Veneta IT",
        "url": "https://www.bottegaveneta.com/en-it"
    },

     {
        "id": "1100l52aaG",
        "network": "Partnerize",
        "name": "Bottega Veneta DE",
        "url": "https://www.bottegaveneta.com/en-de"
    },
      {
        "id": "1100l52aaG",
        "network": "Partnerize",
        "name": "Bottega Veneta DE",
        "url": "https://www.bottegaveneta.com/de-de"
    },
      {
        "id": "1100l52aaH",
        "network": "Partnerize",
        "name": "Bottega Veneta FR",
        "url": "https://www.bottegaveneta.com/en-fr"
    },
    {
        "id": "1100l52aaH",
        "network": "Partnerize",
        "name": "Bottega Veneta FR",
        "url": "https://www.bottegaveneta.com/fr-fr"
    },
    {
        "id": "1101l52bKm",
        "network": "Partnerize",
        "name": "Bottega Veneta AU",
        "url": "https://www.bottegaveneta.com/en-au"
    },
    {
        "id": "1110lkkka",
        "network": "Partnerize",
        "name": "Bottega Veneta CA",
        "url": "https://www.bottegaveneta.com/en-ca"
    },
      {
        "id": "1100l52aaF",
        "network": "Partnerize",
        "name": "Bottega Veneta INT",
        "url": "https://www.bottegaveneta.com/en-en"
    },

     {
        "id": "1101l5KsnT",
        "network": "Partnerize",
        "name": "Dolce & Gabbana UK",
        "url": "https://www.dolcegabbana.com/en-gb"
    },

     {
        "id": "1101l5KsnU",
        "network": "Partnerize",
        "name": "Dolce & Gabbana US",
        "url": "https://www.dolcegabbana.com/en-us"
    },

     {
        "id": "1101l5KsnS",
        "network": "Partnerize",
        "name": "Dolce & Gabbana IT",
        "url": "https://www.dolcegabbana.com/en-it"
    },
    {
        "id": "1101l5KsnS",
        "network": "Partnerize",
        "name": "Dolce & Gabbana IT",
        "url": "https://www.dolcegabbana.com/it-it"
    },

     {
        "id": "1101l5KsnP",
        "network": "Partnerize",
        "name": "Dolce & Gabbana DE",
        "url": "https://www.dolcegabbana.com/en-de"
    },
      {
        "id": "1101l5KsnP",
        "network": "Partnerize",
        "name": "Dolce & Gabbana DE",
        "url": "https://www.dolcegabbana.com/de-de"
    },

       {
        "id": "1101l5KsnR",
        "network": "Partnerize",
        "name": "Dolce & Gabbana FR",
        "url": "https://www.dolcegabbana.com/en-fr"
    },
      {
        "id": "1101l5KsnR",
        "network": "Partnerize",
        "name": "Dolce & Gabbana FR",
        "url": "https://www.dolcegabbana.com/fr-fr"
    },
     {
        "id": "1101l5rUfN",
        "network": "Partnerize",
        "name": "Miu Miu DE",
        "url": "https://www.miumiu.com/de"
    },
     {
        "id": "1101l5rUfN",
        "network": "Partnerize",
        "name": "Miu Miu EU",
        "url": "https://www.miumiu.com/eu"
    },
     {
        "id": "1101l5rUfN",
        "network": "Partnerize",
        "name": "Miu Miu IT",
        "url": "https://www.miumiu.com/it"
    },
     {
        "id": "1101l5rUfN",
        "network": "Partnerize",
        "name": "Miu Miu FR",
        "url": "https://www.miumiu.com/fr"
    },
    {
        "id": "1101l5rUfQ",
        "network": "Partnerize",
        "name": "Miu Miu US",
        "url": "https://www.miumiu.com/us"
    },
     {
        "id": "1101l5rUfP",
        "network": "Partnerize",
        "name": "Miu Miu GB",
        "url": "https://www.miumiu.com/gb"
    },
     {
        "id": "1110lkkpC",
        "network": "Partnerize",
        "name": "Prada GB",
        "url": "https://www.prada.com/gb"
    },
     {
        "id": "1110lkkpD",
        "network": "Partnerize",
        "name": "Prada US",
        "url": "https://www.prada.com/us"
    },
     {
        "id": "1110lkkpB",
        "network": "Partnerize",
        "name": "Prada IT",
        "url": "https://www.prada.com/it"
    },
    {
        "id": "1110lkkpy",
        "network": "Partnerize",
        "name": "Prada DE",
        "url": "https://www.prada.com/de"
    },
     {
        "id": "1110lkkpz",
        "network": "Partnerize",
        "name": "Prada FR",
        "url": "https://www.prada.com/fr"
    },
    {
        "id": "1100lqYUs",
        "network": "Partnerize",
        "name": "Farfetch UK",
        "url": "https://www.farfetch.com/uk"
    },

  {
        "id": "1100lqYUs",
        "network": "Partnerize",
        "name": "Farfetch UK",
        "url": "https://www.farfetch.com/gb"
    },
    {
        "id": "1011l52cBG",
        "network": "Partnerize",
        "name": "ASICS UK",
        "url": "https://www.asics.com/gb"
    },
     {
        "id": "1101l5rUf2",
        "network": "Partnerize",
        "name": "Merrell UK",
        "url": "https://www.merrell.com/UK/"
    },
      {
        "id": "1101l5rUf2",
        "network": "Partnerize",
        "name": "Merrell UK",
        "url": "https://www.merrell.com/uk/"
    },
     {
        "id": "1101l5rUf3",
        "network": "Partnerize",
        "name": "Merrell DE",
        "url": "https://www.merrell.com/DE/"
    },
     {
        "id": "1101l5rUf3",
        "network": "Partnerize",
        "name": "Merrell DE",
        "url": "https://www.merrell.com/de/"
    },
     {
        "id": "1101l5rUf5",
        "network": "Partnerize",
        "name": "Merrell FR",
        "url": "https://www.merrell.com/FR/"
    },
     {
        "id": "1101l5rUf5",
        "network": "Partnerize",
        "name": "Merrell FR",
        "url": "https://www.merrell.com/fr/"
    },
      {
        "id": "1101l5rUfC",
        "network": "Partnerize",
        "name": "Saucony UK",
        "url": "https://www.saucony.com/UK"
    },
        {
        "id": "1101l5rUfC",
        "network": "Partnerize",
        "name": "Saucony UK",
        "url": "https://www.saucony.com/uk"
    },
     {
        "id": "1101l5rUfF",
        "network": "Partnerize",
        "name": "Saucony FR",
        "url": "https://www.saucony.com/FR"
    },
      {
        "id": "1101l5rUfF",
        "network": "Partnerize",
        "name": "Saucony FR",
        "url": "https://www.saucony.com/fr"
    },
     {
        "id": "1101l5rUfG",
        "network": "Partnerize",
        "name": "Saucony DE",
        "url": "https://www.saucony.com/DE"
    },
       {
        "id": "1101l5rUfG",
        "network": "Partnerize",
        "name": "Saucony DE",
        "url": "https://www.saucony.com/de"
    },
      {
        "id": "1101l5rUfD",
        "network": "Partnerize",
        "name": "Saucony IT",
        "url": "https://www.saucony.com/IT"
    },
      {
        "id": "1101l5rUfD",
        "network": "Partnerize",
        "name": "Saucony IT",
        "url": "https://www.saucony.com/it"
    },
    {
        "id": "1011l5yjpe",
        "network": "Partnerize",
        "name": "SSENSE",
        "url": "https://www.ssense.com"
    },
    {
        "id": 45342,
        "network": "Rakuten",
        "name": "Bloomingdales Australia",
        "url": "http://www.bloomingdales.com"
    },
    {
        "id": 50454,
        "network": "Rakuten",
        "name": "Naked Wolfe",
        "url": "https://nakedwolfe.com"
    },
    {
        "id": "stockx.pvxt.net/WqP9Ae",
        "network": "Impact",
        "name": "StockX",
        "url": "https://stockx.com"
    },
     {
        "id": "go.pxf.io/kOXkYd",
        "network": "Impact",
        "name": "Norman Walsh",
        "url": "https://normanwalsh.com"
    },

     {
        "id": 560,
        "network": "Rakuten",
        "name": "Rakuten Advertising Welcome Program",
        "url": "https://rakutenadvertising.com"
    },
    {
        "id": 13867,
        "network": "Rakuten",
        "name": "Bloomingdale's",
        "url": "http://www.bloomingdales.com"
    },
    {
        "id": 24274,
        "network": "Rakuten",
        "name": "Rakuten Marketing UK",
        "url": "http://marketing.rakuten.com/"
    },
    {
        "id": 35718,
        "network": "Rakuten",
        "name": "ASOS (UK)",
        "url": "http://www.asos.com/"
    },
    {
        "id": 36813,
        "network": "Rakuten",
        "name": "Tessabit (UK) - Beat srl",
        "url": "https://www.tessabit.com/en_gb"
    },
    {
        "id": 37119,
        "network": "Rakuten",
        "name": "TESSABIT (US) - Beat srl",
        "url": "https://www.tessabit.com/"
    },
    {
        "id": 37206,
        "network": "Rakuten",
        "name": "Bloomingdales UK",
        "url": "http://www1.bloomingdales.com"
    },
    {
        "id": 37981,
        "network": "Rakuten",
        "name": "Bloomingdales Australia",
        "url": "http://www.bloomingdales.com/"
    },
      {
        "id": 46111,
        "network": "Rakuten",
        "name": "Chloe",
        "url": "https://www.chloe.com"
    },
    {
        "id": 37998,
        "network": "Rakuten",
        "name": "Eleonora Bonucci",
        "url": "https://eleonorabonucci.com/linkshare_entry"
    },
    {
        "id": 38180,
        "network": "Rakuten",
        "name": "Timberland UK",
        "url": "https://www.timberland.co.uk/"
    },
    {
        "id": 38479,
        "network": "Rakuten",
        "name": "aldoshoes.com USA",
        "url": "http://www.aldoshoes.com/"
    },
    {
        "id": 39476,
        "network": "Rakuten",
        "name": "James Perse Enterprises",
        "url": "http://www.jamesperse.com"
    },
    {
        "id": 39514,
        "network": "Rakuten",
        "name": "Superga UK",
        "url": "http://www.superga.co.uk"
    },
    {
        "id": 41446,
        "network": "Rakuten",
        "name": "Athletic Propulsion Labs",
        "url": "https://www.athleticpropulsionlabs.com"
    },
    {
        "id": 41610,
        "network": "Rakuten",
        "name": "SSENSE GLOBAL",
        "url": "https://www.ssense.com"
    },
    {
        "id": 43654,
        "network": "Rakuten",
        "name": "Tory Burch UK",
        "url": "https://www.toryburch.com/en-gb/"
    },
 
    {
        "id": 43730,
        "network": "Rakuten",
        "name": "Teva",
        "url": "https://www.teva.com"
    },
    {
        "id": 43864,
        "network": "Rakuten",
        "name": "Foot Locker AU",
        "url": "http://www.footlocker.com.au/"
    },
    {
        "id": 43953,
        "network": "Rakuten",
        "name": "JD Sports",
        "url": "http://www.jdsports.com"
    },
    {
        "id": 43969,
        "network": "Rakuten",
        "name": "JW Anderson",
        "url": "https://www.jwanderson.com/"
    },
    {
        "id": 44704,
        "network": "Rakuten",
        "name": "Valentino",
        "url": "https://www.valentino.com"
    },
    {
        "id": 45046,
        "network": "Rakuten",
        "name": "Grenson",
        "url": "https://www.grenson.com/uk/"
    },
    {
        "id": 45342,
        "network": "Rakuten",
        "name": "HOKA CA",
        "url": "http://www.hokaoneone.com"
    },
    {
        "id": 45692,
        "network": "Rakuten",
        "name": "Carmen Sol",
        "url": "https://carmensol.com/"
    },
     {
        "id": 53822,
        "network": "Rakuten",
        "name": "Casablanca",
        "url": "https://casablancaparis.com"
    },
    {
        "id": 46038,
        "network": "Rakuten",
        "name": "Ferragamo",
        "url": "https://www.ferragamo.com/"
    },
    {
        "id": 46038,
        "network": "Rakuten",
        "name": "Ferragamo",
        "url": "https://www.ferragamo.com/shop/us/en"
    },
    {
        "id": 47730,
        "network": "Rakuten",
        "name": "Fenwick",
        "url": "https://www.fenwick.co.uk/"
    },
    {
        "id": 53763,
        "network": "Rakuten",
        "name": "Fendi",
        "url": "https://www.fendi.com/us-en/"
    },
    {
        "id": 48150,
        "network": "Rakuten",
        "name": "Diesel Europe",
        "url": "https://www.diesel.com/"
    },
    {
        "id": 49384,
        "network": "Rakuten",
        "name": "Diesel US",
        "url": "https://www.diesel.com/"
    },
       {
        "id": 37490,
        "network": "Rakuten",
        "name": "Gucci US",
        "url": "https://www.gucci.com/us"
    },
         {
        "id": 37933,
        "network": "Rakuten",
        "name": "Gucci UK",
        "url": "https://www.gucci.com/uk"
    },
      {
        "id": 50221,
        "network": "Rakuten",
        "name": "Gucci EU",
        "url": "https://www.gucci.com/it"
    },
        {
        "id": 50221,
        "network": "Rakuten",
        "name": "Gucci EU",
        "url": "https://www.gucci.com/fr"
    },
    {
        "id": 50221,
        "network": "Rakuten",
        "name": "Gucci EU",
        "url": "https://www.gucci.com/nl"
    },
    {
        "id": 49976,
        "network": "Rakuten",
        "name": "Oliver Spencer",
        "url": "https://oliverspencer.co.uk/"
    },
        {
        "id": 49987,
        "network": "Rakuten",
        "name": "Isabel Marant",
        "url": "https://isabelmarant.com"
    },
    {
        "id": 49987,
        "network": "Rakuten",
        "name": "Isabel Marant",
        "url": "https://us.isabelmarant.com"
    },
    {
        "id": 49987,
        "network": "Rakuten",
        "name": "Isabel Marant",
        "url": "https://intl.isabelmarant.com/en-gb"
    },
    {
        "id": 50454,
        "network": "Rakuten",
        "name": "Naked Wolfe",
        "url": "https://nakedwolfe.com/"
    },
    {
        "id": 50502,
        "network": "Rakuten",
        "name": "Paul Smith USA",
        "url": "https://www.paulsmith.com/us"
    },
    {
        "id": 50509,
        "network": "Rakuten",
        "name": "A.P.C. US",
        "url": "https://www.apc-us.com/"
    },
    {
      "id": "brooksrunning.sjv.io/nLDRvM",
      "network": "Impact",
      "name": "Brooks Running",
      "url": "https://www.brooksrunning.com/en_us"
    },
     {
      "id": "mizunoemea.pxf.io/N9J6Ab",
      "network": "Impact",
      "name": "Mizuno",
      "url": "https://emea.mizuno.com"
    },
    {
      "id": "goat.sjv.io/VmobDM",
      "network": "Impact",
      "name": "GOAT",
      "url": "https://www.goat.com"
    },
      {
        "id": "salomon.pxf.io/xLoL5O",
        "network": "Impact",
        "name": "Salomon",
        "url": "https://www.salomon.com/en-us"
    },
    {
        "id": "16327",
        "network": "Awin",
        "name": "Nike",
        "url": "https://www.nike.com/gb"
    },
      {
        "id": "77022",
        "network": "Awin",
        "name": "Adidas UK",
        "url": "https://www.adidas.co.uk"
    },
      {
        "id": "77010",
        "network": "Awin",
        "name": "Adidas FR",
        "url": "https://www.adidas.fr"
    },
         {
        "id": "77004",
        "network": "Awin",
        "name": "Adidas DE",
        "url": "https://www.adidas.de"
    },
    {
        "id": "endclothing.sjv.io/jeDLP5",
        "network": "Impact",
        "name": "END. Clothing",
        "url": "https://www.endclothing.com"
    },
    
]

window.advertisers= advertisers;